<template>
  <section class="sky-review">
    <header>
      <div class="flow-btn">
        <button @click.prevent="$emit('back')">{{ $t('buttons.back') }}</button>
      </div>
      <div class="title">
        <h1>{{ $t('sky.title.review') }}:</h1>
      </div>
      <div class="flow-btn">
        <button @click="nextStep">{{ $t('buttons.saveFinish') }}</button>
      </div>
    </header>
    <div class="groups" :class="$route.params.type">
      <div v-for="(fields, language) in this.languageFields" :key="language" class="group" :class="checkFieldsComplete(fields) ? '' : 'error'">
        <router-link v-if="isEditable(fields)" :to="`/sky/${$route.params.type}/${$route.params.id}/${language}`">Edit</router-link>
        <div v-for="field in fields" :key="field.id" class="field" :class="!field.value || field.value === '' ? 'error' : ''">
          <label>{{ field.label }} ({{ language | lang }}):</label>
          <div v-if="field.type === 'file'" class="field-value">{{ uploadFilename(field.value) || '(no value)' }}</div>
          <div v-else class="field-value">{{ field.value || '(no value)' }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import skyFields from '@/testdata/skyFields'
import { SAVE_SKY_OBJECT } from '@/store/actions.type'
// import { TOGGLE_TAGS_CHECKED } from '@/store/mutations.type'
// import { mapGetters } from 'vuex'

export default {
  name: 'sky-review',
  components: {
    // ToggleButton
  },
  props: {
    languageFields: {
      type: Object,
      default: () => {}
    },
    type: String,
    typeCamel: String
  },
  data() {
    return {}
  },
  computed: {
    // isFilledOut() {
    //   return this.fields.every(field => {
    //     return field.value && field.value !== ''
    //   })
    // }
  },
  methods: {
    nextStep() {
      const saveObject = {
        languages: {}
      }
      saveObject.unique_id = this.$route.params.id
      for (const language in this.languageFields) {
        if (this.languageFields.hasOwnProperty(language)) {
          const fields = this.languageFields[language]
          if (!saveObject.languages.hasOwnProperty(language)) {
            saveObject.languages[language] = {}
          }
          fields.forEach(field => {
            if (field.cropdata && skyFields[this.typeCamel] && skyFields[this.typeCamel][language]) {
              const fieldProps = skyFields[this.typeCamel][language].find(f => f.id === field.id);
              if (fieldProps) {
                saveObject.languages[language][field.id] = {
                  key: field.value,
                  left: Math.round(field.cropdata.x),
                  top: Math.round(field.cropdata.y),
                  width: Math.round(field.cropdata.width),
                  height: Math.round(field.cropdata.height),
                  targetWidth: fieldProps.width,
                  targetHeight: fieldProps.height,
                };
              }
            } else {
              saveObject.languages[language][field.id] = field.value || null
            }
          });
        }
      }
      const loader = this.$loading.show()
      this.$store.dispatch(SAVE_SKY_OBJECT, {
        type: this.type,
        data: saveObject
      }).then(() => {
        loader.hide()
        this.$emit('next')
      }).catch(() => {
        window.alert('There was an error saving the Sky Object. Please try again.')
        loader.hide()
      })
    },
    checkFieldsComplete(fields) {
      return fields.every(field => {
        return field.value && field.value !== ''
      })
    },
    isEditable(fields) {
      return fields.some(field => !field.disabled)
    },
    uploadFilename(filename) {
      return filename ? filename.split('\\').pop().split('/').pop() : filename
    }
  },
  filters: {
    lang(language) {
      if (language === 'en-US') return 'English US'
      else if (language === 'en-CA') return 'English CA'
      else if (language === 'fr-CA') return 'French'
      else if (language === 'es-MX') return 'Spanish'
    }
  }
}
</script>

<style lang="scss" scoped>
.groups {
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 500px;

  &.subscription {
    flex-direction: row;
    width: 100%;

    .group {
      flex: 1 1 33.333%;

      & + .group {
        margin-left: 25px;
      }
    }
  }
}
.group {
  text-align: left;
  background-color: #fff;
  padding: 45px 50px;
  margin-bottom: 25px;
  position: relative;

  &.error {
    border: 1px solid #eb3323;
  }
  > a {
    position: absolute;
    top: 45px;
    right: 50px;
  }
}
.fields {
  text-align: left;
  margin: auto;
  width: 400px;
}
.field {
  & + .field {
    margin-top: 45px;
  }
  label {
    color: #898989;
    font-weight: 300;
  }
  .field-value {
    font-weight: 600;
    overflow-wrap: break-word;
    margin-top: 15px;
  }
  &.error {
    color: #eb3323;
    
    label {
      color: inherit;
    }
  }
}
textarea {
  height: 1.43em;
}
</style>
